import React, { useState } from 'react';
import { purchasesStorage } from '../../services/localStorage.service';
import './PurchasesExpenses.css';

// Icon Components
const EditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.75 2.25C13.0815 1.91848 13.5312 1.73438 14 1.73438C14.4688 1.73438 14.9185 1.91848 15.25 2.25C15.5815 2.58152 15.7656 3.03122 15.7656 3.5C15.7656 3.96878 15.5815 4.41848 15.25 4.75L5.5 14.5L1.75 15.75L3 12L12.75 2.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const DeleteIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75 4.5H14.25M7.5 7.5V12.75M10.5 7.5V12.75M5.25 4.5L5.625 13.5C5.625 14.1213 6.12868 14.625 6.75 14.625H11.25C11.8713 14.625 12.375 14.1213 12.375 13.5L12.75 4.5M6.75 4.5V3C6.75 2.58579 7.08579 2.25 7.5 2.25H10.5C10.9142 2.25 11.25 2.58579 11.25 3V4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PurchasesExpenses = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    distributorName: '',
    contactNumber: '',
    date: '',
    amount: '0.00',
    purchaseType: 'Cash Purchase',
    notes: '',
  });

  const [recentPurchases] = useState([
    { id: 1, date: '2024-07-20', type: 'Cash', amount: '₹ 1,500.00', notes: 'Medical supplies for OPD' },
    { id: 2, date: '2024-07-19', type: 'Credit', amount: '₹ 8,500.00', notes: 'New diagnostic equipment' },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);

    try {
      const purchaseData = {
        description: formData.notes || `${formData.distributorName} - ${formData.purchaseType}`,
        amount: parseFloat(formData.amount || 0),
        category: formData.purchaseType,
        payment_type: formData.purchaseType.includes('Cash') ? 'Cash' : 'Credit',
        paymentType: formData.purchaseType.includes('Cash') ? 'Cash' : 'Credit',
        date: formData.date || new Date().toISOString().split('T')[0],
        distributor_name: formData.distributorName || null,
        distributorName: formData.distributorName,
        contact_number: formData.contactNumber || null,
        contactNumber: formData.contactNumber,
      };

      const newPurchase = purchasesStorage.create(purchaseData);
      
      if (newPurchase) {
        setSuccess('Purchase/Expense recorded successfully!');
        // Reset form
        setFormData({
          distributorName: '',
          contactNumber: '',
          date: '',
          amount: '0.00',
          purchaseType: 'Cash Purchase',
          notes: '',
        });
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError('Failed to record purchase. Please try again.');
      }
    } catch (err) {
      console.error('Error creating purchase:', err);
      setError('Failed to record purchase. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const totalPurchase = parseFloat(formData.amount || 0).toFixed(2);

  return (
    <div className="purchases-expenses">
      <div className="purchases-expenses-header">
        <h1 className="page-title">Purchases/Expenses</h1>
      </div>
      {error && (
        <div style={{ 
          color: '#ef4444', 
          padding: '10px', 
          marginBottom: '15px', 
          backgroundColor: '#fee2e2', 
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          {error}
        </div>
      )}
      {success && (
        <div style={{ 
          color: '#10b981', 
          padding: '10px', 
          marginBottom: '15px', 
          backgroundColor: '#d1fae5', 
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          {success}
        </div>
      )}

      <div className="purchases-expenses-content">
        <div className="purchases-expenses-card">
          <h2 className="card-title">Record New Purchase/Expense</h2>
          <form onSubmit={handleSubmit} className="purchases-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="distributorName">Distributor Name</label>
                <input
                  type="text"
                  id="distributorName"
                  name="distributorName"
                  value={formData.distributorName}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter distributor name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="contactNumber">Contact Number</label>
                <input
                  type="text"
                  id="contactNumber"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter contact number"
                />
              </div>
              <div className="form-group">
                <label htmlFor="date">Date</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="amount">Amount</label>
                <input
                  type="number"
                  id="amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="0.00"
                />
              </div>
              <div className="form-group">
                <label htmlFor="purchaseType">Purchase Type</label>
                <select
                  id="purchaseType"
                  name="purchaseType"
                  value={formData.purchaseType}
                  onChange={handleChange}
                  className="form-input"
                >
                  <option>Cash Purchase</option>
                  <option>Credit Purchase</option>
                </select>
              </div>
            </div>

            <div className="form-row full-width">
              <div className="form-group">
                <label htmlFor="notes">Optional Notes</label>
                <textarea
                  id="notes"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  className="form-input"
                  rows="3"
                  placeholder="Enter any relevant notes..."
                />
              </div>
            </div>

            <div className="total-purchase">
              <span className="total-label">Total Purchase:</span>
              <span className="total-amount">₹ {totalPurchase}</span>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Recording...' : 'Save Record'}
              </button>
            </div>
          </form>
        </div>

        <div className="purchases-history">
          <div className="history-header">
            <h2 className="card-title">History</h2>
            <button className="btn btn-secondary" style={{ backgroundColor: '#e2e8f0', color: '#1e293b' }}>
              Add Filters
            </button>
          </div>

          <div className="recent-purchases-card">
            <h2 className="card-title">Recent Purchases/Expenses</h2>
            <table className="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Amount (₹)</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {recentPurchases.map((purchase) => (
                  <tr key={purchase.id}>
                    <td>{purchase.date}</td>
                    <td>{purchase.type}</td>
                    <td className="amount-cell">{purchase.amount}</td>
                    <td>{purchase.notes}</td>
                    <td>
                      <div className="action-buttons">
                        <button className="action-btn edit-btn" title="Edit">
                          <EditIcon />
                        </button>
                        <button className="action-btn delete-btn" title="Delete">
                          <DeleteIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchasesExpenses;

